module.exports = __webpack_public_path__ + "img/logo_mark.c0c7ebe1.svg";